import React, { Fragment, useEffect } from "react";

import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Customization from "./Customization";
import isEmpty from "../../../../store/validation/is-Empty";
import AddButton from "./AddButton";
import { Col, Container, Row, Image } from "react-bootstrap";
import { ITEMTYPEVEG } from "../../../../enums/OrderEnums";
import moment from "moment";

let soldOutStyle = {
  opacity: 0.5,
  cursor: "no-drop",
};

export const OrdersRequestInsideList = (props) => {
  const [show, setShow] = React.useState(props.data.id ? true : true);
  const [data, setData] = React.useState(props.data);
  const [custom, setCustom] = React.useState(false);

  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  const VegNonVegItem = (data, showVeg, orderSelected, search, hideSoldOut) => {
    let filterData = [];
    if (!showVeg) {
      filterData = data?.items;
    } else if (showVeg) {
      filterData = data?.items?.filter((newData) => newData?.itemType === 1);
    }

    if (hideSoldOut) {
      filterData = filterData?.filter(
        (newData) => newData?.availability === "AVAILABLE"
      );
    }

    const filteredArr = filterData?.filter((review) => {
      return review.name.toLowerCase().includes(search.toLowerCase());
    });

    const availableTime = (cardData) => {
      const day = moment().format("dddd").toLowerCase();
      if (cardData[day].open) {
        let currentTime = "";
        const timeStamp = moment().unix();
        (cardData[day].multiple_timings || []).map((time) => {
          if (moment(timeStamp).isBefore(time?.closing_time))
            currentTime = `${moment(time?.opening_time).format(
              "hh:mm A"
            )}-\n${moment(time?.closing_time).format("hh:mm A")}`;
        });
        return currentTime || "-";
      }
      return "-";
    };

    try {
      if (!isEmpty(filteredArr)) {
        return filteredArr?.map((card, index) => (
          <Fragment key={index}>
            {" "}
            <Col
              md={11}
              style={{
                marginTop: "2%",
                marginLeft: "2%",
                ...(card?.availability !== "AVAILABLE" && soldOutStyle),
              }}
              disabled={card?.availability !== "AVAILABLE"}
              key={index}
            >
              <Card style={{ width: "100%" }}>
                <CardActionArea>
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h2"
                      className="d-flex"
                      style={{ fontWeight: "bold" }}
                      component="h2"
                    >
                      {ITEMTYPEVEG.map((type, index) => {
                        return (
                          <React.Fragment key={index}>
                            {card?.itemType === type?.value ? (
                              <Image
                                width="20px"
                                height="20px"
                                src={type.url}
                                alt={type.title}
                                title={type.title}
                                fluid
                              />
                            ) : null}
                          </React.Fragment>
                        );
                      })}{" "}
                      <span
                        style={{
                          fontSize: ".95rem",
                          fontWeight: "bold",
                        }}
                      >
                        {card.name}
                      </span>
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      component="p"
                    >
                      <Row>
                        <Col sm={9}>
                          <table style={{ width: "100%" }}>
                            <tbody>
                              <tr>
                                <td>
                                  <img
                                    src={require("../../../../assets/images/superadmin/ordericon/rupees.svg")}
                                    width="30px"
                                    alt="Img"
                                  />{" "}
                                </td>
                                <td>
                                  <span style={{ fontWeight: "bold" }}>
                                    {card[orderSelected].sizes.map(
                                      (item, index) => (
                                        <Fragment key={index}>
                                          {item.isDefault ? item.price : <> </>}
                                        </Fragment>
                                      )
                                    )}
                                  </span>
                                  <br />
                                  <span style={{ fontSize: ".9rem" }}>
                                    Price
                                  </span>
                                </td>
                                <td style={{ width: "25px" }}>
                                  <br />
                                </td>
                                <td>
                                  <img
                                    src={require("../../../../assets/images/superadmin/ordericon/clock (2).svg")}
                                    width="30px"
                                    alt="img"
                                  />{" "}
                                </td>
                                <td>
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "#EE3A23",
                                    }}
                                  >
                                    {card.prepTime} Mins
                                  </span>
                                  <br />
                                  <span style={{ fontSize: ".9rem" }}>
                                    Preparation Time
                                  </span>
                                </td>
                                <td colSpan={5}>
                                  <br />
                                </td>
                              </tr>
                              <tr>
                                <td colSpan={10}>
                                  <hr />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <img
                                    src={require("../../../../assets/images/superadmin/ordericon/serves.svg")}
                                    width="30px"
                                    alt="img"
                                  />{" "}
                                </td>
                                <td>
                                  <span style={{ fontWeight: "bold" }}>
                                    {card[orderSelected].sizes.map(
                                      (item, index) => (
                                        <Fragment key={index}>
                                          {item.isDefault ? item.pax : <> </>}
                                        </Fragment>
                                      )
                                    )}
                                  </span>
                                  <br />
                                  <span style={{ fontSize: ".9rem" }}>
                                    Serves
                                  </span>
                                </td>
                                <td style={{ width: "25px" }}>
                                  <br />
                                </td>
                                <td>
                                  <img
                                    src={require("../../../../assets/images/superadmin/ordericon/clock.svg")}
                                    width="30px"
                                    alt="img"
                                  />{" "}
                                </td>
                                <td>
                                  <span style={{ fontWeight: "bold" }}>
                                    {/* {card.atime} */}
                                    {availableTime(card)}
                                  </span>
                                  <br />
                                  <span style={{ fontSize: ".9rem" }}>
                                    Available Time
                                  </span>
                                </td>
                                <td>
                                  <img
                                    src={card?.primary_food_type?.icon}
                                    width="30px"
                                    // alt="img"
                                  />{" "}
                                </td>
                                <td>
                                  <span style={{ fontWeight: "bold" }}>
                                    {card.primary_food_type?.title}
                                  </span>
                                  <br />
                                  <span style={{ fontSize: ".9rem" }}>
                                    Food Type
                                  </span>
                                </td>
                                <td style={{ width: "25px" }}>
                                  <br />
                                </td>
                                <td>
                                  <img
                                    src={require("../../../../assets/images/superadmin/ordericon/calories.svg")}
                                    width="30px"
                                    alt="img"
                                  />{" "}
                                </td>
                                <td>
                                  <span style={{ fontWeight: "bold" }}>
                                    {card[orderSelected].sizes.map(
                                      (item, index) => (
                                        <Fragment key={index}>
                                          {item.isDefault ? (
                                            item.calories
                                          ) : (
                                            <> </>
                                          )}
                                        </Fragment>
                                      )
                                    )}
                                  </span>
                                  <br />
                                  <span style={{ fontSize: ".9rem" }}>
                                    Calories Count
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </Col>
                        <Col sm={3}>
                          {props.cart === 0 ? (
                            <div align="center">
                              <Customization
                                open={custom}
                                setOpen={setCustom}
                                incrementHandler={props.incrementHandler}
                              />
                            </div>
                          ) : (
                            // <Button
                            //   size="large"
                            //   className="btn btn-danger btn-lg"
                            //   style={{ color: "white" }}
                            // >
                            //   Add&nbsp;&nbsp;
                            //   <span style={{ fontSize: ".75rem" }}>
                            //     Customize
                            //   </span>
                            // </Button>
                            <div
                              class="pl-md-2 enPartyPersonEdit"
                              align="center"
                              style={{ width: "65%" }}
                            >
                              <AddButton
                                disabled={card?.availability !== "AVAILABLE"}
                                customizationData={card}
                                orderSelected={orderSelected}
                                categoryName={data.name}
                              />

                              {/* <div class=" align-items-center">
                              <button
                                type="button"
                                class="p-0 btn btn-link"
                                onClick={props.decrementHandler}
                              >
                                <img
                                  src={require("../../../../assets/images/superadmin/ordericon/less.svg")}
                                  alt="Minus"
                                  title="Minus"
                                  class="img-fluid"
                                  width="30px"
                                />
                              </button>
                              <input
                                placeholder="00"
                                value={props.cart}
                                class="enInputValueOnly f12-700"
                                width="30px"
                                onChange={() => {}}
                              />
                              <button
                                type="button"
                                class="p-0 btn btn-link"
                                onClick={props.incrementHandler}
                              >
                                <img
                                  src={require("../../../../assets/images/superadmin/ordericon/add.svg")}
                                  alt="Minus"
                                  title="Minus"
                                  class="img-fluid"
                                  width="30px"
                                />
                              </button>
                            </div> */}
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Col>
          </Fragment>
        ));
      } else {
        return null;
      }
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <Container fluid>
      <div className="body-orders-requests">
        <h4>
          <b>{data.name}</b> &nbsp;
          {!data.sub && (
            <span>
              <span style={{ color: "#EE3A23" }}>
                {data && data.items && data.items.length} Items
              </span>
              <p
                style={{ float: "right" }}
                align="right"
                onClick={() => {
                  setShow(!show);
                }}
              >
                {/* {show ? "hide" : "show"} */}
                {show ? (
                  <i className="fa fa-chevron-up" aria-hidden="true"></i>
                ) : (
                  <i className="fa fa-chevron-down" aria-hidden="true"></i>
                )}
              </p>
            </span>
          )}
        </h4>
      </div>
      {data.sub &&
        data.subdata.map((data, index) => {
          return (
            <OrdersRequestInsideList
              key={index}
              data={data}
              cart={props.cart}
              decrementHandler={props.decrementHandler}
              incrementHandler={props.incrementHandler}
              updateCart={props.updateCart}
              style={{ padding: "15px" }}
            />
          );
        })}
      {show && (
        <div>
          <Row>
            {/* {data.data.map((card, index) => {
              return (
                <Col
                  md={11}
                  style={{ marginTop: "2%", marginLeft: "2%" }}
                  key={index}
                >
                  <Card style={{ width: "100%" }}>
                    <CardActionArea>
                      <CardContent>
                        <Typography
                          gutterBottom
                          variant="h2"
                          className="d-flex"
                          style={{ fontWeight: "bold" }}
                          component="h2"
                        >
                          <img
                            src={
                              card.vegtype === 0
                                ? require("../../../../assets/images/superadmin/ordericon/veg.svg")
                                : require("../../../../assets/images/superadmin/ordericon/non veg.svg")
                            }
                            width="20px"
                            heigth="20px"
                            style={{ marginRight: "15px" }}
                          />
                          <span
                            style={{
                              fontSize: ".95rem",
                              fontWeight: "bold",
                            }}
                          >
                            {card.title}
                          </span>
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          component="p"
                        >
                          <Row>
                            <Col sm={8}>
                              <table style={{ width: "100%" }}>
                                <tbody>
                                  <tr>
                                    <td>
                                      <img
                                        src={require("../../../../assets/images/superadmin/ordericon/rupees.svg")}
                                        width="30px"
                                      />{" "}
                                    </td>
                                    <td>
                                      <span style={{ fontWeight: "bold" }}>
                                        {card.price}
                                      </span>
                                      <br />
                                      <span style={{ fontSize: ".9rem" }}>
                                        Price
                                      </span>
                                    </td>
                                    <td style={{ width: "25px" }}>
                                      <br />
                                    </td>
                                    <td>
                                      <img
                                        src={require("../../../../assets/images/superadmin/ordericon/clock (2).svg")}
                                        width="30px"
                                      />{" "}
                                    </td>
                                    <td>
                                      <span
                                        style={{
                                          fontWeight: "bold",
                                          color: "#EE3A23",
                                        }}
                                      >
                                        {card.ptime}
                                      </span>
                                      <br />
                                      <span style={{ fontSize: ".9rem" }}>
                                        Preparation Time
                                      </span>
                                    </td>
                                    <td colSpan={5}>
                                      <br />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colSpan={10}>
                                      <hr />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <img
                                        src={require("../../../../assets/images/superadmin/ordericon/serves.svg")}
                                        width="30px"
                                      />{" "}
                                    </td>
                                    <td>
                                      <span style={{ fontWeight: "bold" }}>
                                        {card.servers}
                                      </span>
                                      <br />
                                      <span style={{ fontSize: ".9rem" }}>
                                        Serves
                                      </span>
                                    </td>
                                    <td style={{ width: "25px" }}>
                                      <br />
                                    </td>
                                    <td>
                                      <img
                                        src={require("../../../../assets/images/superadmin/ordericon/clock.svg")}
                                        width="30px"
                                      />{" "}
                                    </td>
                                    <td>
                                      <span style={{ fontWeight: "bold" }}>
                                        {card.atime}
                                      </span>
                                      <br />
                                      <span style={{ fontSize: ".9rem" }}>
                                        Available Time
                                      </span>
                                    </td>
                                    <td>
                                      <img
                                        src={require("../../../../assets/images/superadmin/ordericon/halal.svg")}
                                        width="30px"
                                      />{" "}
                                    </td>
                                    <td>
                                      <span style={{ fontWeight: "bold" }}>
                                        {card.ftype}
                                      </span>
                                      <br />
                                      <span style={{ fontSize: ".9rem" }}>
                                        Food Type
                                      </span>
                                    </td>
                                    <td style={{ width: "25px" }}>
                                      <br />
                                    </td>
                                    <td>
                                      <img
                                        src={require("../../../../assets/images/superadmin/ordericon/calories.svg")}
                                        width="30px"
                                      />{" "}
                                    </td>
                                    <td>
                                      <span style={{ fontWeight: "bold" }}>
                                        {card.cal}
                                      </span>
                                      <br />
                                      <span style={{ fontSize: ".9rem" }}>
                                        Calories Count
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </Col>
                            <Col sm={4}>
                              {props.cart === 0 ? (
                                <div align="center">
                                  <Customization
                                    open={custom}
                                    setOpen={setCustom}
                                    incrementHandler={props.incrementHandler}
                                  />
                                </div>
                              ) : (
                                // <Button
                                //   size="large"
                                //   className="btn btn-danger btn-lg"
                                //   style={{ color: "white" }}
                                // >
                                //   Add&nbsp;&nbsp;
                                //   <span style={{ fontSize: ".75rem" }}>
                                //     Customize
                                //   </span>
                                // </Button>
                                <div
                                  class="pl-md-2 enPartyPersonEdit"
                                  align="center"
                                >
                                  <div class=" align-items-center">
                                    <button
                                      type="button"
                                      class="p-0 btn btn-link"
                                      onClick={props.decrementHandler}
                                    >
                                      <img
                                        src={require("../../../../assets/images/superadmin/ordericon/less.svg")}
                                        alt="Minus"
                                        title="Minus"
                                        class="img-fluid"
                                        width="30px"
                                      />
                                    </button>
                                    <input
                                      placeholder="00"
                                      value={props.cart}
                                      class="enInputValueOnly f12-700"
                                      width="30px"
                                      onChange={() => {}}
                                    />
                                    <button
                                      type="button"
                                      class="p-0 btn btn-link"
                                      onClick={props.incrementHandler}
                                    >
                                      <img
                                        src={require("../../../../assets/images/superadmin/ordericon/add.svg")}
                                        alt="Minus"
                                        title="Minus"
                                        class="img-fluid"
                                        width="30px"
                                      />
                                    </button>
                                  </div>
                                </div>
                              )}
                            </Col>
                          </Row>
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Col>
              );
            })} */}
            {VegNonVegItem(
              data,
              props.showVeg,
              props.orderSelected,
              props.search,
              props.hideSoldOut
            )}
          </Row>
        </div>
      )}
    </Container>
  );
};
